/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * DRAFT — being prepared, cannot be filled in. ACTIVE — can be filled in. RETIRED — cannot be filled in any more; the definition and its answers stay.
 * @export
 * @enum {string}
 */

export const SurveyStatusDto = {
    Draft: 'DRAFT',
    Active: 'ACTIVE',
    Retired: 'RETIRED'
} as const;

export type SurveyStatusDto = typeof SurveyStatusDto[keyof typeof SurveyStatusDto];



